module.exports = __webpack_public_path__ + "static/media/bank4.9e176e7c.png";